import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddNewCategoryDialogsComponent } from './add-new-category-dialogs.component';
import { SelectOutletModule } from '../../addcategory/select-outlet/select-outlet.module';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { SelectOutletActivationModule } from '../../addcategory/select-outlet-activation/select-outlet-activation.module';
import { SelectOutletActivationResultModule } from '../../addcategory/select-outlet-activation-result/select-outlet-activation-result.module';

@NgModule({
  declarations: [AddNewCategoryDialogsComponent],
  imports: [
    CommonModule,
    SelectOutletModule,
    SelectOutletActivationModule,
    MatDialogModule,
    TranslateModule,
    SelectOutletActivationResultModule,
  ],
  exports: [AddNewCategoryDialogsComponent],
})
export class AddNewCategoryDialogsModule {}
